/**
 * Shared constants + helpers for the Quiz Editor surfaces.
 *
 * Extracted verbatim from QuizEditorPage.jsx during the Phase 3 refactor
 * (no behaviour change).
 */
import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';

export const SIMPLE_TYPES = new Set(['multiple_choice', 'mcq', 'true_false']);

// Stable id for React keys on transient option editor rows. Plain array
// indices collapse when an option is removed mid-list and steal focus from
// the wrong <input>; a per-row uid solves that cleanly.
export function optUid() {
  return `o_${Math.random().toString(36).slice(2, 10)}_${Date.now().toString(36)}`;
}

export const REVIEW_PILL = {
  approved: { label: 'Approved', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200', Icon: CheckCircle2 },
  pending:  { label: 'Pending review', cls: 'bg-amber-50 text-amber-700 border-amber-200', Icon: AlertTriangle },
  rejected: { label: 'Rejected', cls: 'bg-red-50 text-red-700 border-red-200', Icon: XCircle },
};

/**
 * Effective review status for a question card.
 *
 * Post-bug-fix (Feb 2026) the backend now serialises `ai_review_status` so we
 * have the real state. But for safety in case a stale build is in front of a
 * newer backend (or vice-versa):
 *   - non-AI questions inherit 'approved' (no review required)
 *   - AI-generated questions with no status default to 'pending' — that's the
 *     safe assumption since the auto-insert flow always seeds them pending
 *
 * Previously the entire codebase used `q.ai_review_status || 'approved'`,
 * which silently painted AI questions as approved when the API dropped the
 * field — causing the UI to lie to trainers about live-readiness.
 */
export function effectiveReviewStatus(q) {
  if (q?.ai_review_status) return q.ai_review_status;
  return q?.ai_generated ? 'pending' : 'approved';
}
